import { useTranslate } from 'shared/lib/i18n'
import { formatDayTime } from 'shared/lib/utils/date'

/**
 * A Point's day as the people around it see it (ticket 45): closed for now since
 * when and why, closed for good (a last pickup only), or its hours today by its
 * week. The server says it (`closure`, `closedSince`, `closureComment`, `today` on
 * a Trip's stop, on the hub's choice of Points, on the operator's Point); this only
 * puts it into words. The week forbids nothing — it is a hint.
 */
export interface PointDay {
	closure: 'temporarily' | 'for_good' | null
	closedSince: Date | string | null
	closureComment: string | null
	today: {
		dayOff: boolean
		hours: { from: string; to: string } | null
		lunch: { from: string; to: string } | null
	} | null
}

/** The words of a Point's day: its closing (or `null`) and its hours today (or `null`). */
export function usePointDayWords() {
	const { t } = useTranslate()
	return (day: PointDay): { closure: string | null; today: string | null } => {
		const closure =
			day.closure === 'temporarily'
				? t('pointDay.closedSince', {
						date: formatDayTime(day.closedSince ?? undefined),
						comment: day.closureComment ?? '',
					})
				: day.closure === 'for_good'
					? t('pointDay.closedForGood')
					: null
		const today = !day.today
			? null
			: day.today.dayOff || !day.today.hours
				? t('pointDay.todayOff')
				: t('pointDay.todayHours', day.today.hours) +
					(day.today.lunch ? t('pointDay.todayLunch', day.today.lunch) : '')
		return { closure, today }
	}
}
